<template>
	<!-- To be filled by specific implementations -->
</template>

<script>

export default {
	props: {
		searchAllow: { type: Boolean, default: false }, // Adds a search option as first entry
		searchCustom: { type: Boolean, default: false }, // Overrides default search logic. Options must be filtered on your own
		searchDebounce: { type: Number, default: 0 }, // Delay for search requests in ms while user is typing
		searchMinLength: { type: Number, default: 0 }, // Minimum amount of characters required to search
		options: { type: Array, default: null }, // Array of search options
		optionsValueField: { type: String, default: null }, // Field of the options object to be used as internal value. Whole object is used if this is null
		optionsValueGetter: { type: Function, default: null }, // Getter function to assemble the options value
		optionsKeyField: { type: String, default: null }, // Field of the options object to be used as internal key. If not specified options value is used
		optionsKeyGetter: { type: Function, default: null }, // Getter function to assemble the options key
		optionsDisplayField: { type: String, default: null },  // Field of the options object to be used as display value. Whole object is used if this is null
		optionsDisplayGetter: { type: Function, default: null }, // Getter function to assemble the options display value
		noEntriesText: { type: String, default: "" }, // Custom text to show in case the options list is empty
		noSearchResultsText: { type: String, default: "" }, // Custom text to show in case no search results are found
		disabled: { type: Boolean, default: false },
		required: { type: Boolean, default: false }
	},
	data() {
		return {
			searchValue: "",
			searchTimeout: null
		};
	},
	computed: {
		searchResults() {
			if (!this.options) {
				return [];
			}

			return this.searchCustom
				? this.options
				: this.options.filter(item => this.getOptionDisplayValue(item)
					.toLowerCase()
					.includes(this.searchValue.toLowerCase()));
		},
		emptyText() {
			if (this.searchValue) {
				return this.noSearchResultsText || this.$t("common.select.noSearchResults");
			} else {
				return this.noEntriesText || this.$t("common.select.noEntries");
			}
		}
	},
	methods: {
		search(value) {
			this.searchValue = value;

			if (this.searchTimeout) {
				clearTimeout(this.searchTimeout);
			}
			this.searchTimeout = setTimeout(() => {
				if (this.searchMinLength === 0 || (this.searchValue && this.searchValue.length > this.searchMinLength)) {
					this.$emit("search", this.searchValue);
				}
			}, this.searchDebounce);
		},
		resetSearch() {
			this.searchValue = "";
		},
		getOptionValue(option) {
			if (this.optionsValueGetter) {
				return this.optionsValueGetter(option);
			} else {
				return this.optionsValueField ? option[this.optionsValueField] : option;
			}
		},
		getOptionKey(option) {
			if (!this.optionsKeyGetter && !this.optionsKeyField) {
				return this.getOptionValue(option);
			}

			if (this.optionsKeyGetter) {
				return this.optionsKeyGetter(option);
			} else {
				return this.optionsKeyField ? option[this.optionsKeyField] : option;
			}
		},
		getOptionDisplayValue(option) {
			if (this.optionsDisplayGetter) {
				return String(this.optionsDisplayGetter(option));
			} else {
				return String(this.optionsDisplayField ? option[this.optionsDisplayField] : option);
			}
		}
	}
};
</script>